import { FC } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonTextLineLong, SkeletonTextLineShort } from "./styled";

const TextCardsSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      {Array.from({ length: 3 }).map((_, index) => (
        <FlexColumn ai="flex-start" gap={2} key={`text-card-line-${index}`}>
          <SkeletonTextLineShort />
          <SkeletonTextLineLong />
          <SkeletonTextLineLong />
          <SkeletonTextLineLong />
        </FlexColumn>
      ))}
    </ModuleSkeleton>
  );
};

export default TextCardsSkeleton;
